import { Card } from '@talentmesh/ui/components/card';
import EmailVerifiedPageContent from './Components/EmailVerifiedPageContent';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';
import { CompanyLogo } from '@/Components/shared';
import UIStrings from '@/Utils/UIStrings';

function EmailVerified() {
    return (
        <MeshBackgroundCenterOverlay>
            <CompanyLogo
                width={195}
                height={37.5}
                color="primary"
                className="mb-8"
                aria-label={UIStrings.CompanyLogo}
            />
            <Card className="border-border w-full overflow-hidden border p-4 drop-shadow-xl">
                <EmailVerifiedPageContent />
            </Card>
        </MeshBackgroundCenterOverlay>
    );
}

export default EmailVerified;
